/** 기다리던 일보다 중단이 먼저 왔다는 표시. */
export const ABORTED = Symbol('aborted');

/**
 * 기다리는 일을 중단 신호와 경쟁시킨다 — 중단되면 그 일이 끝나길 기다리지 않고 바로 `ABORTED` 를 돌려준다.
 * 기다리던 일 자체는 끊지 않는다(공유 세션 생성·다른 실행도 쓰는 사전 등록처럼 남이 함께 기다리는 일).
 */
export const untilAborted = <T>(
  work: Promise<T>,
  signal: AbortSignal,
): Promise<T | typeof ABORTED> => {
  if (signal.aborted) return Promise.resolve(ABORTED);
  return new Promise((resolve, reject) => {
    const onAbort = () => resolve(ABORTED);
    signal.addEventListener('abort', onAbort, { once: true });
    work.then(
      value => {
        signal.removeEventListener('abort', onAbort);
        resolve(value);
      },
      (error: unknown) => {
        signal.removeEventListener('abort', onAbort);
        reject(error);
      },
    );
  });
};
